import { SupplierForm } from "../../../../purchases"

export const ExpenseSupplierForm = () => {
    return (
        <SupplierForm productSupplier={false} />
    )
}
